import { useQuery } from '@tanstack/react-query'

import { ProductService } from '@/services'
import { useAppSelector } from '@/store/hook'
import { selectUserType } from '@/store/slices/authenticationSlice'
import { USER_TYPES } from '@/libs/constants/user'
import { isValidArray } from '@/libs/utils/array'
import { isEmptyObject } from '@/libs/utils/object'

export const usePromotionQuery = () => {
  const userType = useAppSelector(selectUserType)

  const { data, isFetching } = useQuery({
    queryKey: ['promotion'],
    queryFn: () => ProductService.getPromotionProducts(),
    select: (data) => {
      const { promotionProducts } = data

      if (!isValidArray(promotionProducts)) {
        return []
      }

      return promotionProducts?.filter((product) => !isEmptyObject(product))
    },
    enabled: userType === USER_TYPES.CUSTOMER_USER,
  })

  return {
    data,
    isFetching,
  }
}
